import '~/assets/scss/zpif.scss'

import Accordion from '~/js/modules/accordion';
import Form from '~/js/modules/form';
import '~/js/modules/objects-map';
import '~/js/modules/tabs';
import getSwiperSlider from '~/js/modules/slider';

window.addEventListener(`DOMContentLoaded`, () => {
  const bannersSlider = document.querySelector(`.banners__slider`);
  const forms = document.querySelectorAll(`.form-b__form`);
  const accordions = document.querySelectorAll(`.accordion`);

  if (forms.length) {
    forms.forEach((form) => new Form(form));
  }

  if (accordions.length) {
    accordions.forEach((accordion) => {
      if (!accordion.classList.contains('main-nav__list')) {
        new Accordion(accordion)
      }
    });
  }

  const interleaveOffset = 0.5;
  if (bannersSlider) {
    const bannersSwiperParams = {
      speed: 1000,
      slidesPerView: 1,
      watchSlidesProgress: true,
      navigation: {
        nextEl: `.banners .slider-arrows__arrow--next`,
        prevEl: `.banners .slider-arrows__arrow--prev`,
      },
      pagination: {
        el: `.slider-dots`,
        clickable: true,
        bulletClass: `slider-dots__dot`,
        bulletActiveClass: `active`,
        renderBullet(index, className) {
          return `
            <button class="${className}">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                <circle cx="50" cy="50" r="25"></circle>
              </svg>
            </button>`;
        },
      },
      on: {
        progress() {
          for (let i = 0; i < this.slides.length; i++) {
            const slideProgress = this.slides[i].progress;
            const innerOffset = this.width * interleaveOffset;
            const innerTranslate = slideProgress * innerOffset;
            this.slides[i].querySelector(`.slider-top__image`).style.transform = `translate3d(` + innerTranslate + `px, 0, 0)`;
          }
        },
        touchStart() {
          this.autoplay.stop();
          for (let i = 0; i < this.slides.length; i++) {
            this.slides[i].style.transition = ``;
          }
        },
        touchEnd() {
          this.autoplay.start();
        },
        slideChange() {
          const currentIndex = this.realIndex < 10
            ? `0${this.realIndex + 1}`
            : `${this.realIndex + 1}`;
          this.el.querySelector(`.slider-pages__page--current`).textContent = currentIndex;
        },
        setTransition(speed) {
          for (let i = 0; i < this.slides.length; i++) {
            this.slides[i].style.transition = speed + `ms`;
            this.slides[i].querySelector(`.slider-top__image`).style.transition = speed + `ms`;
          }
        },
      },
    }
    getSwiperSlider(bannersSlider, bannersSwiperParams);
  }

  const fundsSlider = document.querySelector(`.zpif__create-fund-steps`);
  const fundsSwiperParams = {
    wrapperClass: 'zpif__create-fund-steps--inner',
    slideClass: 'zpif__create-fund-steps--step-block',
    spaceBetween: 0,
    slidesPerView: '1.5',

    breakpoints: {
      1024: {
        slidesPerView: '3',
      }
    }
  };
  if (fundsSlider) {
    getSwiperSlider(fundsSlider, fundsSwiperParams);
  }

  const bannerCardsSlider = document.querySelector(`.js-banner-cards`);
  const bannerCardsSwiperParams = {
    wrapperClass: 'wrapper',
    slideClass: 'js-card-slide',
    spaceBetween: 2,
    slidesPerView: '1',

    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    },
    breakpoints: {
      1024: {
        slidesPerView: '4',
        pagination: false,
      }
    }
  };
  if (bannerCardsSlider) {
    getSwiperSlider(bannerCardsSlider, bannerCardsSwiperParams);
  }

  //На странице две одинаковые формы которые конфликтуют из-за одинакового id,
  //поэтому запишем в скрытую форму перед этими формами нужные нам для отправки в CRM значения
  const hiddenForm = document.querySelector('.hidden-form');
  const fakeForm = document.querySelectorAll('.fake-form');

  fakeForm.forEach((form) => {
    form.addEventListener('submit', function (e) {
      const formInputs = this.querySelectorAll(".fake-field")
      formInputs.forEach((input) => {
        let sourceValue = input.getAttribute("data-field");
        let destinationValue = hiddenForm.querySelector('#' + sourceValue);
        //ФИО в CRM идёт с поля name_surname
        if (sourceValue == 'name') {
          hiddenForm.querySelector('#name_surname').value = input.value;
        }
        //тип потребности записываем вручную
        hiddenForm.querySelector('#lead_type_id').value = 'd98cf23d-51a6-449a-97ed-a67961576988';
        destinationValue.value = input.value;
      })
    });
  })

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();

      document.querySelector(this.getAttribute('href')).scrollIntoView();
    });
  });

  window.addEventListener("scroll", event => {
    let fromTop = window.scrollY;
    const sectionBlock = document.querySelectorAll('.scroll-link');

    sectionBlock.forEach((block, index) => {
      let section = document.querySelector(block.hash);
      let previousSection;
      if (index > 0) {
        previousSection = document.querySelector(sectionBlock[index - 1].hash);
      }
      if (section.offsetTop - 350 <= fromTop) {
        block.classList.add("active");

        if (previousSection) {
          sectionBlock[index - 1].classList.remove("active");
        }
      } else {
        block.classList.remove("active");
      }
    });
  });
});
